import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Save, Send, Eye, History } from 'lucide-react';
import { useTranslation } from "react-i18next";

interface PublishingHelpModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const Row: React.FC<{ icon: React.ReactNode; title: string; desc: string }> = ({
  icon,
  title,
  desc,
}) => (
  <div className="flex items-start gap-3">
    <div className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-muted text-foreground">
      {icon}
    </div>
    <div className="min-w-0">
      <p className="text-sm font-medium">{title}</p>
      <p className="text-sm text-muted-foreground">{desc}</p>
    </div>
  </div>
);

export const PublishingHelpModal: React.FC<PublishingHelpModalProps> = ({
  open,
  onOpenChange,
}) => {
  const { t } = useTranslation();
  return (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-lg">
      <DialogHeader>
        <DialogTitle>{t('helpCenter.publishingHelpModal.title')}</DialogTitle>
      </DialogHeader>

      <div className="space-y-4">
        <Row
          icon={<Save className="h-4 w-4" />}
          title={t('helpCenter.publishingHelpModal.saveDraftTitle')}
          desc={t('helpCenter.publishingHelpModal.saveDraftDesc')}
        />
        <Row
          icon={<Send className="h-4 w-4" />}
          title={t('helpCenter.publishingHelpModal.publishTitle')}
          desc={t('helpCenter.publishingHelpModal.publishDesc')}
        />
        <Row
          icon={<Eye className="h-4 w-4" />}
          title={t('helpCenter.publishingHelpModal.visibleTitle')}
          desc={t('helpCenter.publishingHelpModal.visibleDesc')}
        />
        <Row
          icon={<History className="h-4 w-4" />}
          title={t('helpCenter.publishingHelpModal.versionHistoryTitle')}
          desc={t('helpCenter.publishingHelpModal.versionHistoryDesc')}
        />

        <p className="rounded-md bg-muted/50 p-3 text-xs text-muted-foreground">
          {t('helpCenter.publishingHelpModal.newArticlesNote')}
        </p>
      </div>
    </DialogContent>
  </Dialog>
  );
};

export default PublishingHelpModal;
